import { Resource as ResourceInterface, Category } from '../types/resources';

/**
 * Resource model class with utility methods
 */
export class Resource {
  public readonly id: string;
  public readonly title: string;
  public readonly slug: string;
  public readonly excerpt: string;
  public readonly content: string;
  public readonly category: Category;
  public readonly tags: string[];
  public readonly createdAt: Date;
  public readonly updatedAt: Date;
  public readonly featured: boolean;

  constructor(data: ResourceInterface) {
    this.id = data.id;
    this.title = data.title;
    this.slug = data.slug;
    this.excerpt = data.excerpt;
    this.content = data.content;
    this.category = data.category;
    this.tags = data.tags || [];
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.featured = data.featured || false;
  }

  /**
   * Generate the URL for this resource
   * Pattern: /resources/{article-slug}
   */
  getUrl(): string {
    return `/resources/${this.slug}`;
  }

  /**
   * Get formatted creation date
   */
  getFormattedCreatedDate(): string {
    return this.createdAt.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  /**
   * Get formatted updated date
   */
  getFormattedUpdatedDate(): string {
    return this.updatedAt.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  /**
   * Check if resource has a specific tag
   */
  hasTag(tag: string): boolean {
    return this.tags.includes(tag);
  }

  /**
   * Get truncated excerpt with specified length
   */
  getTruncatedExcerpt(maxLength: number = 150): string {
    if (this.excerpt.length <= maxLength) {
      return this.excerpt;
    }
    return this.excerpt.substring(0, maxLength).trim() + '...';
  }
}